import { render, staticRenderFns } from "./DetailsModel.vue?vue&type=template&id=e496f65c&scoped=true&"
import script from "./DetailsModel.vue?vue&type=script&lang=js&"
export * from "./DetailsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e496f65c",
  null
  
)

export default component.exports